// Conteúdo do manual de ajuda por página (gestores e administradores).
//
// Regras de escrita:
// - Linguagem de manual de usuário: o que cada ação faz e as regras de negócio.
// - NÃO mencionar banco de dados, colunas, código ou detalhes técnicos internos.
//
// Cada entrada tem:
//   match: RegExp testada contra o pathname atual (a primeira que casar vence)
//   title: título exibido no topo do painel
//   sections: lista de { heading, items: [ ... ] }

const HELP_ENTRIES = [
  {
    match: /^\/admin\/dashboard/,
    title: "Dashboard",
    sections: [
      {
        heading: "O que é esta página",
        items: [
          "Painel de indicadores gerais do negócio. Disponível apenas para administradores.",
          'O bloco "Visão Geral" mostra a quantidade de pedidos em cada etapa do fluxo (do recebimento até a entrega).',
        ],
      },
      {
        heading: "Números acompanhados",
        items: [
          "Totais consolidados: Total de Usuários, de Pedidos, de Produtos, de Vendas, de Produtos Vendidos e de Pedidos Pendentes.",
          'Operação logística: "Aguardando Envio" e "Aguardando Entrega".',
          'Rankings: Top Distribuidores por valor de vendas e por volume, e Top Gestores por SLA (tempo de atendimento) e por quantidade de produtos.',
        ],
      },
      {
        heading: "Dicas",
        items: [
          "Os números são recalculados conforme os pedidos avançam de status.",
          "Use o menu no topo para ir às demais áreas (Produtos, Pedidos, Usuários).",
        ],
      },
    ],
  },
  {
    match: /^\/admin\/produtos\/novo/,
    title: "Cadastrar novo produto",
    sections: [
      {
        heading: "Como cadastrar",
        items: [
          'Preencha "Código do produto (Deve ser igual ao everest)".',
          'Informe "Nome do produto" e "Preço".',
          '"Quantidade mínima de compra": é o mínimo que o distribuidor pode comprar deste produto. Deixe vazio para considerar 1.',
          'Marque "Destacar produto" para que ele apareça no carrossel da página inicial.',
          'Em "Status do produto", escolha Ativo, Pré-venda ou Inativo.',
          'Em "Tipo (Divisão)", marque PET e/ou EQUI.',
          'Adicione ao menos uma imagem (arraste e solte ou clique para selecionar). Vídeos do YouTube são opcionais.',
          'Preencha a Descrição e clique em "Adicionar" para salvar.',
        ],
      },
      {
        heading: "Regras importantes",
        items: [
          "São obrigatórios: código, nome, preço numérico válido, ao menos uma imagem e ao menos um tipo (PET ou EQUI).",
          "O link de vídeo precisa ser um endereço válido do YouTube.",
          "A quantidade mínima é sempre respeitada na compra: o distribuidor não consegue fechar um pedido abaixo dela.",
          "Produtos Pré-venda aceitam manifestação de interesse, mas não venda imediata.",
          "As variantes (tamanho, cor, etc.) só podem ser cadastradas depois de salvar, na tela de edição.",
        ],
      },
    ],
  },
  {
    match: /^\/admin\/produtos\/editar/,
    title: "Editar produto",
    sections: [
      {
        heading: "Como editar",
        items: [
          "Altere os campos desejados: código, nome, preço, quantidade mínima, destaque, status, tipo, imagens, vídeos e descrição.",
          '"Quantidade mínima de compra": mínimo que o distribuidor pode comprar. Deixe vazio para considerar 1.',
          'Clique em "Salvar" para confirmar as alterações.',
        ],
      },
      {
        heading: "Variantes do Produto",
        items: [
          "Use variantes para vender opções diferentes do mesmo produto (ex.: Tamanho, Cor).",
          'Crie os tipos de atributo no campo "Tipos de atributo" (ex.: Tamanho) e confirme no botão de adicionar.',
          'Em "Selecionar variantes existentes", marque os valores e use "Gerar variantes selecionadas" para criar as combinações automaticamente.',
          'Você também pode usar "Adicionar variante" para criar uma linha manualmente.',
          "Cada variante tem seu próprio Código Everest e Preço (ambos obrigatórios) e um Status (Ativo/Inativo).",
          'Cada linha de variante só é gravada ao clicar em "Salvar"; remova com o botão vermelho ao lado.',
        ],
      },
      {
        heading: "Regras importantes",
        items: [
          "A quantidade mínima vale para o produto como um todo, independente da variante escolhida.",
          "Ao remover uma imagem ela deixa de ser exibida; só passa a valer após salvar.",
        ],
      },
    ],
  },
  {
    match: /^\/admin\/produtos\/[^/]+\/interessados/,
    title: "Interessados / Pré-venda",
    sections: [
      {
        heading: "O que é esta página",
        items: [
          "Lista as pessoas que demonstraram interesse no produto, separadas em duas abas.",
          '"Pré-venda": interessados em produtos com status Pré-venda.',
          '"Aviso": pessoas que pediram para ser avisadas quando o produto ficar disponível.',
          "O tipo de interesse é definido automaticamente pelo status do produto no momento do cadastro do interesse.",
        ],
      },
      {
        heading: "Como usar",
        items: [
          'Alterne entre as abas "Pré-venda" e "Aviso"; o número ao lado de cada aba mostra a quantidade de inscritos.',
          "A tabela traz Nome, Email, Telefone e a data de inscrição de cada pessoa.",
          'Clique no email para abrir o seu programa de e-mail e entrar em contato.',
          'Use "Baixar Excel" para exportar a lista da aba atual e organizar a comunicação do lançamento.',
        ],
      },
    ],
  },
  {
    match: /^\/admin\/produtos/,
    title: "Produtos",
    sections: [
      {
        heading: "O que é esta página",
        items: [
          "Lista todos os produtos cadastrados, com divisão, vendas, estoque, interesse, preço e status.",
          "O contador no topo mostra quantos produtos estão ativos e quantos inativos.",
        ],
      },
      {
        heading: "Ações disponíveis",
        items: [
          'Adicionar novo produto: abre a tela de cadastro.',
          "Editar: clique na linha do produto ou no ícone de lápis para alterar dados, imagens e variantes.",
          "Ativar / Desativar: usa o ícone de olho para controlar se o produto aparece para os distribuidores.",
          "Excluir: disponível apenas para produtos que ainda não tiveram vendas.",
          'Buscar: use "Buscar por nome do produto..." para localizar.',
          'Marque "Ocultar inativos" para ver somente os produtos ativos.',
        ],
      },
      {
        heading: "Estoque, interesse e quantidade mínima",
        items: [
          "A coluna Estoque destaca em vermelho quando o saldo está zerado ou negativo.",
          "Na coluna Interesse, os números de pré-venda e de aviso são clicáveis e levam à lista de interessados.",
          "Cada produto pode ter uma quantidade mínima de compra, sempre respeitada no pedido; quando não definida, o mínimo é 1.",
        ],
      },
    ],
  },
  {
    match: /^\/admin\/vitrine\/produto/,
    title: "Vitrine - Produto (visualização)",
    sections: [
      {
        heading: "O que é esta página",
        items: [
          "Mostra o produto exatamente como o distribuidor o vê, em modo somente leitura.",
          "Gestores e administradores não conseguem adicionar ao carrinho nesta visualização.",
        ],
      },
      {
        heading: "Como usar",
        items: [
          "Confira imagens, descrição, preço, estoque e variantes antes de divulgar o produto.",
        ],
      },
    ],
  },
  {
    match: /^\/admin\/vitrine/,
    title: "Vitrine",
    sections: [
      {
        heading: "O que é esta página",
        items: [
          "Exibe o catálogo de produtos como os distribuidores o veem, em modo somente leitura.",
          "Produtos em destaque aparecem no carrossel no topo; itens de pré-venda ou sem estoque são sinalizados.",
        ],
      },
      {
        heading: "Como usar",
        items: [
          "Como administrador, você pode alternar o filtro de divisão (PET/EQUI) para ver o que cada perfil enxerga.",
          "Clique em um produto para abrir a visualização detalhada.",
        ],
      },
    ],
  },
  {
    match: /^\/admin\/pedidos/,
    title: "Pedidos",
    sections: [
      {
        heading: "O que é esta página",
        items: [
          "Lista os pedidos e o status de cada um. Administradores veem todos; gestores veem os pedidos dos seus distribuidores.",
          '"Aguardando entrada" reúne os pedidos pendentes que ainda precisam ser aprovados.',
          '"Todos os pedidos" mostra a lista completa com a etapa atual de cada pedido.',
        ],
      },
      {
        heading: "Aprovar (registrar entrada)",
        items: [
          'Clique em um pedido pendente para abrir "Entrada de Pedido".',
          'Selecione a Divisão (centro de custo) correspondente.',
          'Clique em "Aprovar" para registrar a entrada: o pedido passa para "Criado" e segue para faturamento.',
          "A divisão escolhida fica vinculada ao pedido e não pode ser trocada depois.",
        ],
      },
      {
        heading: "Cancelar pedido",
        items: [
          'Na tela de entrada, use "Cancelar Pedido" e informe o motivo (obrigatório).',
          "Um pedido cancelado não avança mais no fluxo.",
          "Se o pedido foi pago (total ou parcialmente) com OrgaDots e ainda não tinha sido faturado/separado/enviado/entregue, os OrgaDots são estornados automaticamente ao distribuidor.",
        ],
      },
      {
        heading: "Acompanhamento",
        items: [
          'Use a busca por número do pedido, pedido everest, data ou distribuidor, e o filtro de status (Todos, Pendente, Criado, Entregue, Cancelado).',
          "Clique em qualquer pedido para abrir os detalhes com itens, quantidades e valores.",
          "O fluxo de status avança em uma direção e não retrocede; o cancelamento é uma saída à parte.",
        ],
      },
    ],
  },
  {
    match: /^\/admin\/usuarios\/novo/,
    title: "Cadastrar novo usuário",
    sections: [
      {
        heading: "Como cadastrar",
        items: [
          'Preencha "Nome de Usuário" (usado para login, mínimo 3 caracteres), "Nome Completo" (nome e sobrenome), "Email" e "Telefone".',
          'Em "Funções", escolha o papel: Administrador, Gestor ou Distribuidor (as opções de admin/gestor aparecem apenas para administradores).',
          'Defina a senha em "Definir senha"; opcionalmente marque para enviá-la por email ao usuário após a criação.',
          'Clique em "Criar Usuário".',
        ],
      },
      {
        heading: "Regras por perfil",
        items: [
          "Distribuidor: exige um Gestor responsável, um CNPJ válido e o Tipo (PET ou EQUI).",
          "Gestor: exige o Tipo (PET ou EQUI). Administrador não tem tipo.",
          "A senha deve ter no mínimo 6 caracteres e a confirmação precisa conferir.",
          "Email e CNPJ não podem se repetir entre usuários.",
        ],
      },
    ],
  },
  {
    match: /^\/admin\/usuarios\/editar/,
    title: "Editar usuário",
    sections: [
      {
        heading: "Como editar",
        items: [
          "Altere nome de usuário, nome completo, email, telefone, função e, para distribuidores, gestor, CNPJ e tipo.",
          'A senha só é alterada se você marcar "Alterar senha" e preencher a nova senha (mínimo 6 caracteres) com a confirmação.',
          'Clique em "Salvar Edição" para confirmar.',
        ],
      },
      {
        heading: "Regras por perfil",
        items: [
          "Trocar a função para Distribuidor exige informar gestor, CNPJ válido e tipo (PET ou EQUI).",
          "Gestor exige tipo (PET ou EQUI); administrador não tem tipo.",
        ],
      },
    ],
  },
  {
    match: /^\/admin\/usuarios/,
    title: "Usuários",
    sections: [
      {
        heading: "O que é esta página",
        items: [
          "Lista os usuários (distribuidores, gestores e administradores) com nome de usuário, nome, email e tipo de acesso.",
          "Cada perfil enxerga apenas os usuários que pode gerenciar.",
        ],
      },
      {
        heading: "Ações disponíveis",
        items: [
          'Adicionar Usuário: abre a tela de cadastro.',
          "Editar: clique na linha do usuário para alterar dados e função.",
          "Excluir: use o ícone vermelho ao final da linha; o acesso do usuário é desativado.",
          'Buscar: use "Procurar usuário..." para localizar por nome, email ou nome de usuário.',
        ],
      },
    ],
  },
  {
    match: /^\/admin\/orgadots/,
    title: "OrgaDots - Gestão de Créditos",
    sections: [
      {
        heading: "O que é esta página",
        items: [
          "Gerencia os OrgaDots, o saldo que os distribuidores podem usar como forma de pagamento nos pedidos.",
          'A tela tem três abas: "Crédito Mensal", "Crédito/Débito Manual" e "Consultar Extrato".',
        ],
      },
      {
        heading: "Aba Crédito Mensal — passo a passo",
        items: [
          'Em "Configuração Geral", defina o Período (Início e Fim), o Percentual (%) e o Percentual Meta (%). Esses campos já vêm pré-preenchidos com valores padrão, que você pode ajustar.',
          "Como administrador, escolha também a Divisão (PET ou EQUI); o gestor já trabalha sobre a própria divisão.",
          'Na tabela "Distribuidores", marque/desmarque cada distribuidor que entrará no lançamento (a marca verde indica incluído).',
          'Use "Exceção" em uma linha para definir percentual, meta ou período diferentes só para aquele distribuidor; "Remover Exceção" volta a herdar a configuração geral.',
          'Clique em "Salvar rascunho" para gravar o lançamento em aberto (uma linha por distribuidor marcado).',
          'Clique em "Simular Todos" para calcular o valor de cada distribuidor; o resultado aparece na coluna "Valor Calculado". Você também pode calcular uma linha por vez no ícone de calculadora.',
          'Confira os valores e clique em "Aprovar e Creditar" para lançar os créditos.',
        ],
      },
      {
        heading: "Regras do crédito mensal",
        items: [
          "Só é possível aprovar depois de simular: cada distribuidor precisa ter um valor calculado para entrar na aprovação.",
          "A aprovação é definitiva e imediata: os OrgaDots caem no saldo do distribuidor na hora e o lançamento não volta a ser rascunho.",
          'Enquanto não aprovar, o lançamento fica em rascunho/simulado e pode ser ajustado; "Descartar rascunho" remove os registros em aberto daquela divisão.',
          "Editar uma linha já simulada apaga o valor calculado dela, exigindo nova simulação antes de aprovar.",
          'A área "Histórico — créditos aprovados" lista, apenas para consulta, os lotes já lançados.',
        ],
      },
      {
        heading: "Aba Crédito/Débito Manual",
        items: [
          "Lançamento avulso para um distribuidor: selecione o Distribuidor, o Tipo (Crédito ou Débito), o Valor e o Motivo / Descrição.",
          "O motivo é obrigatório.",
          "Um débito só é aceito se o distribuidor tiver saldo suficiente.",
        ],
      },
      {
        heading: "Aba Consultar Extrato",
        items: [
          'Selecione o distribuidor e clique em "Consultar" para ver o saldo atual e o histórico de movimentações (crédito/débito, origem e descrição).',
        ],
      },
    ],
  },
  {
    match: /^\/admin\/perfil/,
    title: "Perfil",
    sections: [
      {
        heading: "O que é esta página",
        items: [
          "Permite atualizar seus próprios dados de acesso: Nome, Email e Telefone/Whatsapp.",
          "Inclui também a alteração da sua senha.",
        ],
      },
      {
        heading: "Como usar",
        items: [
          "O telefone deve conter 11 dígitos (DDD + número).",
          "Para trocar a senha, informe a senha atual, a nova senha (mínimo 6 caracteres) e a repetição dela.",
          'Clique em "Salvar" para aplicar as alterações.',
        ],
      },
    ],
  },
  {
    match: /^\/admin\/extrato/,
    title: "Extrato",
    sections: [
      {
        heading: "O que é esta página",
        items: [
          "Mostra o seu saldo de OrgaDots e o histórico de movimentações.",
        ],
      },
      {
        heading: "Como usar",
        items: [
          "Cada lançamento indica data, tipo (crédito ou débito), origem (cálculo mensal, manual ou compra), descrição e valor.",
          "Use o histórico para conferir entradas e saídas do saldo.",
        ],
      },
    ],
  },
  // fallback para o painel admin (ex.: rota inicial /admin)
  {
    match: /^\/admin/,
    title: "Painel administrativo",
    sections: [
      {
        heading: "Como navegar",
        items: [
          "Use o menu no topo para acessar as áreas disponíveis para o seu perfil (Vitrine, Pedidos, Produtos, Usuários, OrgaDots e Perfil).",
          "Em cada página, o painel de ajuda traz as orientações específicas daquela tela.",
        ],
      },
    ],
  },
];

const DEFAULT_HELP = {
  title: "Ajuda",
  sections: [
    {
      heading: "Manual",
      items: [
        "Esta página ainda não possui um manual detalhado.",
        "Use o menu para navegar entre as áreas do sistema.",
      ],
    },
  ],
};

export function getHelpForPath(pathname) {
  const entry = HELP_ENTRIES.find((e) => e.match.test(pathname));
  return entry || DEFAULT_HELP;
}

export default HELP_ENTRIES;
